
export const mockDataProjects=[
    {
        "id": "1",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "5.8",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "LOST",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "2",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "7",
        "loa_expected_by": "17-03-2023",
        "remarks": "Need to offer Diff Capex Model ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "Extreme",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "3",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS2",
        "credit_rating": "A",
        "dc_capacity_mwp": "4.9",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Need to be discussed with Mani & team to get details on connectivity permissions",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "4",
        "fy": "21-22",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "4.8",
        "ppa_tariff": "3.65",
        "status": "Lost",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "Lost",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "5",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "3",
        "loa_expected_by": "17-02-2023",
        "remarks": "Pratik finding out reference.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "6",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "50",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "27-01-2023",
        "remarks": "Will be take up after December",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "7",
        "fy": "21-22",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "120",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Follow up done for meeting request. Need to connect with Mr. Gopal Kumar Menon.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "8",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "A",
        "dc_capacity_mwp": "28",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"20.07- Proposal submitted to client."
    },
    {
        "id": "9",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.75",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Dropped",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "10",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "9",
        "loa_expected_by": "31-03-2023",
        "remarks": "Offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "11",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "6.6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "15",
        "loa_expected_by": "12-05-2023",
        "remarks": "We are only party they are discussing with and expected to receive LOA by next week.  Project Team has to give feedback either to go for 445Wp or 540Wp. As per the input project team is going to reject 540Wp option. As per the input 1.03.2021 project team is sending their recommendation to corporate office. And they are recommending 445Wp module. In that case we are L1 and LOA will be issued. Project team has recommended 445WP and CEO has to give the approval. Approval for 445Wp has been received and as per the update Mr. Parag Wagh will contact us by Monday or Tuesday to initiate the further process. Parag told that he will close this in April 2021. Confirmation to be given on our proposal submitted earlier. This will be finally closed by next week.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "12",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "11",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "22",
        "loa_expected_by": "30-06-2023",
        "remarks": "Viability lost due to policy ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "13",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.8",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "13",
        "loa_expected_by": "28-04-2023",
        "remarks": "12.5 MWp Offer Submitted.Higher management meeting done waiting for Land tech DD ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "14",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.8",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "10",
        "loa_expected_by": "07-04-2023",
        "remarks": "Waiting for Policy clerance",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "Hot",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "15",
        "fy": "21-22",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "29",
        "ppa_tariff ": "3.75",
        "status": "Lost",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Revised Offer to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "16",
        "fy": "21-22",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "24.3",
        "ppa_tariff ": "3.80",
        "status": "LOA",
        "weeks_loa_expected": "7",
        "loa_expected_by": "17-03-2023",
        "remarks": "Offer submitted awaiting for meeting with CFO. Meeting likely to be in April.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "17",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "1.3",
        "ppa_tariff ": "3.75",
        "status": "LOA",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "Awaiting Management Approval. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "18",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "26",
        "ppa_tariff ": "4.35",
        "status": "LOA",
        "weeks_loa_expected": "0",
        "loa_expected_by": "27-01-2023",
        "remarks": "Revised offer to be submitted. LOA has been received on 31.03.2022",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "19",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "7.5",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Offer Submitted. Awaiting Details from Customer for meeting. Revised Offer needs to be submitted & conference call needs to be arranged. Order has been closed with Sun Source at Rs. 28/Wp",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "20",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "3.65",
        "status": "Lost",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "Order has gone to Rays Power",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "21",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "9.5",
        "ppa_tariff ": "3.95",
        "status": "Lost",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "We are 2nd in Reverse Bidding. Management still not taken the decision. Management has gone for Capex project.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "22",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Rajasthan ",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "200",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "20",
        "loa_expected_by": "16-06-2023",
        "remarks": "Lost Not interested",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "23",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "23",
        "loa_expected_by": "07-07-2023",
        "remarks": "Lost to Tata",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "24",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "17",
        "ppa_tariff ": "3.21",
        "status": "Lost",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "Order received. PPA needs to ve signed by Wednesday",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "Offer Submission and discussion with higher management",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "25",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "11.2",
        "ppa_tariff ": "3.60",
        "status": "LOA",
        "weeks_loa_expected": "5",
        "loa_expected_by": "03-03-2023",
        "remarks": "Offer Submitted. Follow up Done. Awaiting Meeting Details for Commercial Discussion",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "26",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.75",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Offer Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "27",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "2",
        "loa_expected_by": "10-02-2023",
        "remarks": "Awaiting Management Approval. Need Differed Capex",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "28",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "11.31",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Proposal under review. EB bills received ananlysis will be completed by Sunday.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "29",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Awaiting Management Approval. Need Differed Capex",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "30",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Revised offer to be submitted as per new PIS",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "Warm",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "31",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "33",
        "loa_expected_by": "15-09-2023",
        "remarks": "PPA draft submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "Warm",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "32",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "Put on Hold  ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "33",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "7.5",
        "ppa_tariff ": "4.15",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Two option given. March 2023 + 2 months grace delivery- Rs. 4.15 & Rs. 3.9 for 12 months delivery",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "Hot",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "34",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "35.1",
        "ppa_tariff ": "3.6",
        "status": "Warm",
        "weeks_loa_expected": "4",
        "loa_expected_by": "",
        "remarks": "Final Meeting expected Next week",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "Hot",
        "PPA Rs/Kwh for 15 yrs": "Design Stage",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "35",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "31",
        "loa_expected_by": "01-09-2023",
        "remarks": "Opex is under pursual",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "Hot",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "36",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "AA",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "RFQ will be shared with us by this month end.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "37",
        "fy": "21-22",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Haryana",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "Unrated",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "12",
        "loa_expected_by": "21-04-2023",
        "remarks": "Design Stage",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "38",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "16",
        "loa_expected_by": "19-05-2023",
        "remarks": "in Discussion",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "39",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Uttarakhand",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "0.3",
        "ppa_tariff ": "3.9",
        "status": "Cold",
        "weeks_loa_expected": "27",
        "loa_expected_by": "04-08-2023",
        "remarks": "Offer Submitted for Gujarat and AP proposal is pending. Requested for EB bills for AP location. There is future potential of around 15- 20 MW for 3 location  that includes KA, GJ and UK. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "40",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "1.5",
        "ppa_tariff ": "3.85",
        "status": "Cold",
        "weeks_loa_expected": "13",
        "loa_expected_by": "28-04-2023",
        "remarks": "Meeting is schedule for 8th Feb 2021. Meeting on 15th Feb in Bangalore. Proposal for Bidadi has only shared. We have confirmed the pre mature termination clause and guaranteed saving of Rs 1/KWh. Awaiting for customer confirmation",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "41",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "14",
        "loa_expected_by": "05-05-2023",
        "remarks": "Porposal submiited for RT Capex ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "42",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "10",
        "loa_expected_by": "07-04-2023",
        "remarks": "Received. Project on Hold",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "43",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "45",
        "loa_expected_by": "08-12-2023",
        "remarks": "Offer submitted. Customer is  looking for Zero Investment under EMI.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "44",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "32",
        "loa_expected_by": "08-09-2023",
        "remarks": "Offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "45",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "25",
        "loa_expected_by": "21-07-2023",
        "remarks": "Revised Offer submitted under EMI model.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "46",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.3",
        "ppa_tariff ": "3.85",
        "status": "Lost",
        "weeks_loa_expected": "12",
        "loa_expected_by": "21-04-2023",
        "remarks": "LOA Awaited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "47",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "17",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "16",
        "loa_expected_by": "19-05-2023",
        "remarks": "Offer to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "48",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "35",
        "ppa_tariff ": "3.9",
        "status": "Warm",
        "weeks_loa_expected": "3",
        "loa_expected_by": "17-02-2023",
        "remarks": "All details have been provided. Awaiting for customer feedback. Technical discussion completed and by 19.2.2021 we are going to have PPA discussion. Awaiting for feedback from Finance Team of Shivam Autotech. Finance team requires few more days to go through the tem sheet. It will be taken up after 3-4 months",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "49",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "0.8",
        "ppa_tariff ": "4.05",
        "status": "LOA",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "All the queries have been replied. SHA is shared and under review.  Meeting has been done with Juniper Team and all the required details as requested by them has been shared. Proposal is under review with USA team. It will take a month time for closure. BY 2nd week of April we are expecting update from Juniper USA team. Deferred Capex proposal to be shared as an option. PPT regarding GCOA is under review and will be sent by tomorrow.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "50",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "Offer is under review with management. Monday 15.2.2021 we are having meeting with management.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "51",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "4.5",
        "status": "Cold",
        "weeks_loa_expected": "34",
        "loa_expected_by": "22-09-2023",
        "remarks": "Recap has agreed for Tariff rate of Rs. 3.9/ Unit with Solar edge inverter. Offer is already submitted. After TN election they will initiate the discussion.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "52",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "MH, KA,UP, GJ",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "1.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Commercial offer submitted for 4 locations in Bangalore",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "53",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "37",
        "loa_expected_by": "13-10-2023",
        "remarks": "Customer is priority for Short Term Supply. Awaiting for customer meeting",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "54",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "23",
        "loa_expected_by": "07-07-2023",
        "remarks": "Lost Upon pricing ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "Floating Pump ",
        "AC Capacity-Mw": "Cold",
        "PPA Rs/Kwh for 15 yrs": "Lost Upon pricing ",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "55",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "25",
        "loa_expected_by": "21-07-2023",
        "remarks": "Term sheet conditions not acceptable ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "Offer to be resubmitted ",
        "AC Capacity-Mw": "Hot",
        "PPA Rs/Kwh for 15 yrs": "New quote to be submitted ",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "56",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "20",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "27",
        "loa_expected_by": "04-08-2023",
        "remarks": "Offer submitted ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "Offer to be resubmitted ",
        "AC Capacity-Mw": "Hot",
        "PPA Rs/Kwh for 15 yrs": "Stand AloneGrid tied  Highway project New  Offer to be submitted ",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "57",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "28",
        "loa_expected_by": "11-08-2023",
        "remarks": "LOA Awaited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "Querries Raised ",
        "AC Capacity-Mw": "Hot",
        "PPA Rs/Kwh for 15 yrs": "Discussion stage ,Querries raised awaititng answers ",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "58",
        "fy": "21-22",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "15.7",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "15",
        "loa_expected_by": "12-05-2023",
        "remarks": "Offer submitted but office closed due to corona cases ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "Design stage ",
        "AC Capacity-Mw": "Warm",
        "PPA Rs/Kwh for 15 yrs": "Design stage ",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "59",
        "fy": "21-22",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "3.7",
        "status": "Cold",
        "weeks_loa_expected": "16",
        "loa_expected_by": "19-05-2023",
        "remarks": "LOA Received",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "60",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "27",
        "loa_expected_by": "04-08-2023",
        "remarks": "No response from client",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "61",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.15",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "18",
        "loa_expected_by": "02-06-2023",
        "remarks": "Offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "62",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "7.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "19",
        "loa_expected_by": "09-06-2023",
        "remarks": "Revised offer to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "63",
        "fy": "21-22",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "13",
        "loa_expected_by": "28-04-2023",
        "remarks": "No response from client",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "64",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.7",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "10",
        "loa_expected_by": "07-04-2023",
        "remarks": "No response from client",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "65",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "West Bengal",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "2.2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "7",
        "loa_expected_by": "17-03-2023",
        "remarks": "No response from client",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "66",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Rajasthan",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "reply is expected post covid",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "67",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "14",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "3",
        "loa_expected_by": "17-02-2023",
        "remarks": "Offer Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "68",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Telangana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Term sheet submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "69",
        "fy": "21-22",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "AA",
        "dc_capacity_mwp": "18.5",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "Term sheet submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "70",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "4.2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "Term sheet submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "71",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "150",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "20",
        "loa_expected_by": "16-06-2023",
        "remarks": "EB Bills awaited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "72",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "23",
        "loa_expected_by": "07-07-2023",
        "remarks": "Offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "73",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "150",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "Need to follow up.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "74",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Rajasthan",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "70",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "5",
        "loa_expected_by": "03-03-2023",
        "remarks": "Need to follow up.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "75",
        "fy": "21-22",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "PPA draft submitted by Radiance",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "76",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "2",
        "loa_expected_by": "10-02-2023",
        "remarks": "EB Bills awaited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "77",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "10.5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Commercial offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "78",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "4.15",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Got the concerned person contact details and need to discuss about the requirement and feasibility. Proposal is under review.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "79",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "4.2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "Covid restriction",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "80",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "16.28",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "Covid restriction",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "81",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "2.25",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "20",
        "loa_expected_by": "16-06-2023",
        "remarks": "Need to follow up.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "82",
        "fy": "21-22",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Haryana",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.18",
        "ppa_tariff ": "4",
        "status": "LOA",
        "weeks_loa_expected": "23",
        "loa_expected_by": "07-07-2023",
        "remarks": "Proposal submitted. Likely to be closed in this Month.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "83",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "2.75",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "Awaiting for EB bill. Customer has initially signed an LOA @ 4.25/ Unit in 2017",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "84",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "1.5",
        "ppa_tariff ": "3.68",
        "status": "Cold",
        "weeks_loa_expected": "5",
        "loa_expected_by": "03-03-2023",
        "remarks": "Will be take up after JSW finalization. We need to submit the revise price as requested. As per internal input closingt tariff will be 3.45 to 3.50. This is likely to close by month end.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "85",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "4",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "We are 2nd in Reverse Bidding. Management still not taken the decision. Management has gone for Capex project.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "86",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "2",
        "loa_expected_by": "10-02-2023",
        "remarks": "Radiance has received the LOA from customer. IC Deck Prepared & Shared & PPA discussion is in progress.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "87",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "3.4",
        "status": "Cold",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "88",
        "fy": "21-22",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "9.3",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "PPA discussion is going on.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "89",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "10.5",
        "ppa_tariff ": "4",
        "status": "Lost",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "we have to submit the proposal for TPOA and GCOA. TPOA can be closed in this month and for GCOA it may take 2-3 months of time.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "90",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "16",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "33",
        "loa_expected_by": "15-09-2023",
        "remarks": "Offer Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "91",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "ForeignSubsidiary",
        "dc_capacity_mwp": "16",
        "ppa_tariff ": "",
        "status": "Extreme",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "in Discussion",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "92",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "2.25",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "9",
        "loa_expected_by": "31-03-2023",
        "remarks": "in Discussion",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "93",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "8",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "15",
        "loa_expected_by": "12-05-2023",
        "remarks": "On Hold",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "94",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "1.3",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "22",
        "loa_expected_by": "30-06-2023",
        "remarks": "By 2.08.2021 they will take the update us.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "95",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.25",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "7",
        "loa_expected_by": "17-03-2023",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "96",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "AA",
        "dc_capacity_mwp": "1.7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "Discussion with finance team also done. Now the compliance of all the proposal has been sent for MD approval. Likely to be close in April as they are awaiting for Budget approval. Discussion with Finance team also done on 15.04.2021. And based on the discussion they are going to submit the revised saving calculation sheet for MD approval.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "97",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Delhi NCR ",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "AA",
        "dc_capacity_mwp": "0.025",
        "ppa_tariff ": "4.05",
        "status": "Warm",
        "weeks_loa_expected": "3",
        "loa_expected_by": "17-02-2023",
        "remarks": "Need to submit the revised proposal as the pond area is not approved by PCB. Array layout is prepared . Proposal submitted. Mr. Ramesh will update by next week.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "98",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.7",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Turnkey Project under CAPEX. Customer has given target Rs. 9 Cr for 2.25MWp with pGSMent terms of 25% advance, 70 % against material delivery and 5% after commissioning.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "99",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "4.5",
        "ppa_tariff ": "5.15",
        "status": "LOA",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "we need to submit the proposal for 15 years PPA term. PIS is under review by Pratik. Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "100",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "Awaiting for in principle approval from Nextgen shared the Financial details for evaluation. Recap proposal has been given to customer on 15.4.2021 and awaiting for the feedback.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "101",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "18",
        "ppa_tariff ": "3.53",
        "status": "Cold",
        "weeks_loa_expected": "20",
        "loa_expected_by": "16-06-2023",
        "remarks": "Revised proposal submitted.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "102",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "2.7",
        "ppa_tariff ": "3.6",
        "status": "Cold",
        "weeks_loa_expected": "23",
        "loa_expected_by": "07-07-2023",
        "remarks": "Proposal and Term Sheet has been presented for Board Approval. PIS under review.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "103",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "Proposal has been submitted and awaiting for management meeting. Yesterday project proposal has been submitted to management as per internal input.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "104",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "5",
        "loa_expected_by": "03-03-2023",
        "remarks": "Proposal has been sent to Germany office forfeedback. All the information regarding net metering has shared with client.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "105",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Haryana",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.48",
        "ppa_tariff ": "3.9",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Awaiting for Radiance confirmation on tariff rate of Rs. 3.9/ Unit as requested by Nestle Team",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "106",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "4.1",
        "status": "Cold",
        "weeks_loa_expected": "2",
        "loa_expected_by": "10-02-2023",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "107",
        "fy": "21-22",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "108",
        "fy": "21-22",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.4",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Customer already closed the order. We receive the enquiry very late.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "109",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "8",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Mail sent requesting for input regarding roof details",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "110",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.4",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "33",
        "loa_expected_by": "15-09-2023",
        "remarks": "PIS to be submitted  to Radiance",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "111",
        "fy": "21-22",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "112",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "5.8",
        "ppa_tariff ": "3.6",
        "status": "LOA",
        "weeks_loa_expected": "5",
        "loa_expected_by": "03-03-2023",
        "remarks": "Meeting Schedule for tomorrow 2.30 pm. Need to share actual generation data will be shared by Monday.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "113",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "11.2",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "9",
        "loa_expected_by": "31-03-2023",
        "remarks": "LOA Awaited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "114",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Telangana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "31",
        "loa_expected_by": "01-09-2023",
        "remarks": "New Leads awaiting for more details",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "115",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "New Leads awaiting for more details",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "116",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.78",
        "ppa_tariff ": "4.1",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Third Party",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "117",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "16",
        "loa_expected_by": "19-05-2023",
        "remarks": "New Lead ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "118",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "AA",
        "dc_capacity_mwp": "6.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "27",
        "loa_expected_by": "04-08-2023",
        "remarks": "Awaiting for few more details regarding Financial Report.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "119",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Bihar",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "13",
        "loa_expected_by": "28-04-2023",
        "remarks": "Proposal under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "120",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "14",
        "loa_expected_by": "05-05-2023",
        "remarks": "Proposal Submiited ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "121",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "10",
        "loa_expected_by": "07-04-2023",
        "remarks": "Will be taken up after normalization of production",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "122",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "8",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "45",
        "loa_expected_by": "08-12-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "123",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "8.4",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "32",
        "loa_expected_by": "08-09-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "124",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "30",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "25",
        "loa_expected_by": "21-07-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "125",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "16",
        "loa_expected_by": "19-05-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "126",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "3",
        "loa_expected_by": "17-02-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "127",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "128",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "25.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "34",
        "loa_expected_by": "22-09-2023",
        "remarks": "BTM proposal submitted and customer has told they will revert back after 15 days. Few technical points to be closed.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "129",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttarakhand",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "1.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "35",
        "loa_expected_by": "29-09-2023",
        "remarks": "We have give them solar option earlier but due to policy change they have requested to find better solution",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "130",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "6.3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "37",
        "loa_expected_by": "13-10-2023",
        "remarks": "Offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "131",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "7.5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "25",
        "loa_expected_by": "21-07-2023",
        "remarks": "Offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "132",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Punjab",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "27",
        "loa_expected_by": "04-08-2023",
        "remarks": "Offer to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "133",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "KC",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "16",
        "loa_expected_by": "19-05-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "134",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.95",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "27",
        "loa_expected_by": "04-08-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "135",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "18",
        "loa_expected_by": "02-06-2023",
        "remarks": "New Lead. Wind PIS for MH needs to be submitted to Radiance. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "136",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA",
        "dc_capacity_mwp": "0.42",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Requirement remains same as submitted last year for reverse auction. Require pricing with revised rates. Lost on pricing.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "46"
    },
    {
        "id": "137",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "100",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "13",
        "loa_expected_by": "28-04-2023",
        "remarks": "Offer to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "138",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "13",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "10",
        "loa_expected_by": "07-04-2023",
        "remarks": "Offer to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "139",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "New Lead . PIS submitted to Radiance Awaiting Tariff.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "140",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "7",
        "loa_expected_by": "17-03-2023",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "141",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "Proposal submitted ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "142",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "3",
        "loa_expected_by": "17-02-2023",
        "remarks": "Proposall is under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "143",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "30",
        "ppa_tariff ": "4",
        "status": "Lost",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Offer Submitted today 4 PM meeting scheduled",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "144",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "20",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "EPC Project ,EB Bills & Other details procured .Will submit offer next week ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "145",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "Design Stage,Nagpur Mumbai Highway ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "146",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "20",
        "loa_expected_by": "16-06-2023",
        "remarks": "Details have been shared with Design team for array layout etc.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "147",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "26",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "23",
        "loa_expected_by": "07-07-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "148",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "New Lead - offer Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "149",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "5",
        "loa_expected_by": "03-03-2023",
        "remarks": "Offer submitted ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "150",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Financial Report are shared with Nextgen for approval",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "151",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "9",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Wind Solar Hybrid Park",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "152",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.816",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "153",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "11",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "154",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "155",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "20",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "33",
        "loa_expected_by": "15-09-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "156",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.75",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "157",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "158",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "20",
        "loa_expected_by": "16-06-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "159",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "50",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "23",
        "loa_expected_by": "07-07-2023",
        "remarks": "Offer Submitted. Awaiting LOA. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "160",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Assam",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.564",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "Offer to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "PMC",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "161",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Assam",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "4.18",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "5",
        "loa_expected_by": "03-03-2023",
        "remarks": "New Lead",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "162",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "4.3",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Offer Submitted. Bill analysis is pending. Offer submitted for all 4 locations",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "163",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "4",
        "status": "Cold",
        "weeks_loa_expected": "2",
        "loa_expected_by": "10-02-2023",
        "remarks": "Proposal Submiited ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "164",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "0.375",
        "ppa_tariff ": "3.9",
        "status": "Cold",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "Proposal  will be submitted by tomorrow",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "165",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "30",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "166",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "54",
        "ppa_tariff ": "3.7",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "167",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "7.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "33",
        "loa_expected_by": "15-09-2023",
        "remarks": "New Lead . EB bill analysis will be completed by tomorrow.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "168",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "4.5",
        "ppa_tariff ": "3.75",
        "status": "Cold",
        "weeks_loa_expected": "8",
        "loa_expected_by": "24-03-2023",
        "remarks": "offer submitted this week",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "169",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "27-01-2023",
        "remarks": "New Lead need to get confirmation from Nextgen for loan approval.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "170",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "11",
        "loa_expected_by": "14-04-2023",
        "remarks": "New Lead. Awaiting bills",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "171",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "2.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "27-01-2023",
        "remarks": "Proposal submitted under EMI model. Few clarification is requested from customer will be replied after getting the same from Nextgen.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "172",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "1",
        "loa_expected_by": "03-02-2023",
        "remarks": "The price was on the higher side.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "173",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AR",
        "credit_rating": "A",
        "dc_capacity_mwp": "20",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "5",
        "loa_expected_by": "03-03-2023",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "174",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "6",
        "loa_expected_by": "10-03-2023",
        "remarks": "Revised Offer submitted. Queries have been raised in Design Review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "175",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "2",
        "loa_expected_by": "10-02-2023",
        "remarks": "Revised Offer submitted. Queries have been raised in Design Review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "176",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "4",
        "loa_expected_by": "24-02-2023",
        "remarks": "proposal submitted this week",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "177",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "8.3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "178",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "179",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "180",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "13",
        "ppa_tariff ": "3.8",
        "status": "Warm",
        "weeks_loa_expected": "2",
        "loa_expected_by": "10-02-2023",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "181",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "182",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "AA",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "183",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "0.26",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "184",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "36",
        "ppa_tariff ": "3.5",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "185",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "3.9",
        "ppa_tariff ": "4",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted. We have been shortlisted for 2nd round of discussion.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "186",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "5.4",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted and we have to give clarification to them. Meeting schedule for tomorrow 11 am",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "187",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "1.8",
        "ppa_tariff ": "4.2",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Awaiting  for few more details from client. Put on Hold by client due to other prioirity project.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "188",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "NA",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "189",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "Opex",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "4",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "17.08.2021",
        "remarks": "Proposal submitted. 17.08.2021 final meeting to be done.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "190",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "Opex",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "3.55",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted this week only.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "191",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Punjab",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Closed with Jakson at price Rs 33/ Wp",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "192",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "193",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.3",
        "ppa_tariff ": "4.25",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "194",
        "fy": "21-22",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "3.93",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Offer Submitted. Feedback is expected by Next week. Order was given to Thermex at 38 Rs/ Wp.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "195",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "New lead awaiting for financial approval from Nextgen.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "196",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.15",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "New lead awaiting for financial approval from Nextgen.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "197",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted. We have submit customer details pertaining to generation data and break up of the price.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "198",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "4.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "We have to give proposal for Module first and then EPC work. As customer is planning to purchase the panel this will enable them to cut  project cost later. As plant will be gettting ready by Dec 2021.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "199",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.8",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Shared the details for refrence. Awaiting for the feedback. We need to resubmit the proposal by Tuesday under BTM model.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "200",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Punjab",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.74",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "201",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "7.5",
        "ppa_tariff ": "3.9",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "202",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "203",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "2.55",
        "ppa_tariff ": "3.85",
        "status": "Extreme",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Offer to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "204",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "2.5",
        "ppa_tariff ": "3.8",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under consideration",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "205",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "225",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "LOA shared via email",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "206",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted and under evaluation by customer",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "207",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "9.68",
        "ppa_tariff ": "3.95",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "208",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "6.45",
        "ppa_tariff ": "3.95",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "209",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "8.1",
        "ppa_tariff ": "3.95",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "210",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "3.95",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "211",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Rajasthan",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Revised proposal to be shared.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "212",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Revised proposal shared",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "213",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "2.2",
        "ppa_tariff ": "3.7",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "LOA has been shared with the customer.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "214",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal or capex has been shared yesterday with the customer",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "215",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "45",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "They have got sanction from bank for solar plant, land is also identify by them. Proposal need to submit the for EPC ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "216",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "30",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "As per RJ policy, clients should have positive balance sheet. Waiting for balalnce sheet from clients ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "217",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under review. Client is asking for Park details along with permission letter. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "218",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "In month of Janaury they will start again for dicussion.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "219",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "3.95",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "220",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "4",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "221",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "3.9",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PPA already signed with sunsource",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "222",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "0.6",
        "ppa_tariff ": "4.75",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "223",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "4.1",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "224",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Revised Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "225",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "0.4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Site Survey  done",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "226",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted. Final disccusion to be done by next week.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "227",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "228",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal already submitted.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "229",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal will be submitted  by Monday",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "230",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "3.75",
        "ppa_tariff ": "4.5",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "231",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "4.1",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Propsoal under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "232",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal need to submit. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "233",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Waiting for bill copy from clients side. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "234",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "They have already install 2.5*2 MW on roof-top, proposal need to submit ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "235",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "236",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "18",
        "ppa_tariff ": "",
        "status": "warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "company profile along with park details submitted, proposal need to submit, waiting for bill copy.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "237",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "4.96",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "We are trying to get it done through other sources. As Radiance price is on higher sideer 4.96 fpr 10 years PPA under TPOA model.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "238",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "32",
        "ppa_tariff ": "3.8",
        "status": "Extreme",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "239",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "5.25",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "240",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Orissa",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "0.6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under preparation",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "241",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "West Bengal",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "1.4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under preparation",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "242",
        "fy": "21-22",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Telangana",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.9",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted but the base price was 4.5  where our price offered was 4.70",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "243",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "45",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "CAPEX proposal shared with Client. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "244",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "CAPEX proposal shared with Client.  Awaiting for discussion with HOD.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "245",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "2.78",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Revised Proposal shared and it is under review.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "246",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Punjab",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "under discussion",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "247",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Under Review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "248",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "16",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "LOA received. Request for amended in the LOA regarding BCD clause.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "249",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "6.09",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under Review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "250",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "45",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Revised proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "251",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Sumitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "252",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Awaiting for the EB bills",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "253",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttarakhand",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Site survey will done by 29.12.2021",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "254",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "3.6",
        "ppa_tariff ": "4.3",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "255",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "4.8",
        "ppa_tariff ": "4.5",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "256",
        "fy": "21-22",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Telangana",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under evaluation by customer. Our price is high and customer requested for 36 Rs/ Wp",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "257",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttarakhand",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Site survey will done by 28.12.2021",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "258",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "1.7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted awaiting for the confirmation from Distributed Energies",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "259",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "7.5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "260",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "20",
        "ppa_tariff ": "3.8",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PPA is signed between the developer and Customer. As next steps there will be sseparate EPC contarct to be signed between InSolare and Vigneswara.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "261",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "16",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Kirloskar has given the price of Rs. 3.6 Cr per MWp including land and approvals. Our Price was Rs. 4.4 Cr.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "262",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Bill analysis completd and revised landed sheet to be done considering 66KV voltage.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "263",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.82",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Discussion to be done with customer for understanding the roof profile. Revised proposal for capex has been submitted 17th March 2022.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "264",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "265",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "266",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "267",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "268",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "",
        "credit_rating": "A",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS to be reviewed",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "269",
        "fy": "21-22",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "11",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "LOA received",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "270",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "55",
        "ppa_tariff ": "3.45",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "271",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "7.5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "272",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "17",
        "ppa_tariff ": "3.5",
        "status": "Extreme",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted and awaiting for final discussion with CEO.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "273",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Profile sent ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "274",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal  to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "275",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AR",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal  to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "276",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "6.75",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "277",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "278",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "LOA awaited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "279",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.0",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "280",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "5.0",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "281",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.1",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "282",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.0",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "283",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.0",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "284",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.2",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "285",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.7",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "286",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "4.9",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "287",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "288",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.0",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "289",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.4",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "290",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "291",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "AA-",
        "dc_capacity_mwp": "0.3",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Lost",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "292",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "1.0",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "293",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.0",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "294",
        "fy": "21-22",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "2.0",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "295",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "296",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "5.0",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "297",
        "fy": "21-22",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.4",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "298",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "299",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.2",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "300",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.3",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "301",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "2.0",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "302",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Haryana",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "303",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "304",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "6.7",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "305",
        "fy": "21-22",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "306",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "West Bengal",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "307",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Assam",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.8",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "308",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Jharkhand",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "6.8",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "309",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Punjab",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.6",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "310",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.6",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "311",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Himachal Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "1.0",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "312",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "313",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A-",
        "dc_capacity_mwp": "3.0",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "314",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A-",
        "dc_capacity_mwp": "3.0",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "315",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A+",
        "dc_capacity_mwp": "0.4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "316",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "8.12",
        "ppa_tariff ": "3.9",
        "status": "Warm",
        "weeks_loa_expected": "2",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "317",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "We need to submit the PPT with bill analysis for the management meeting",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "318",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "319",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "21.17",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "320",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Telangana",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1.2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Under progress with design team",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "321",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.6",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "322",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.53",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "323",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "2.25",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Awaiting for the Balance Sheet. EB bill consumption has been received and analysis will be completed by Monday.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "324",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "0.2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Awaiting for roof drawing from customer",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "325",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "4.25",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "TPOA proposal given to the customer. TPOA proposal in line with AT&S project will be shared.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "326",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Madhya Pradesh",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "9",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Lost",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "327",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "3.7",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Meeting with HUL Renewable energy team has been done on 17th March 2022 and we need  to share the revised proposal. Internal approval has been received from HUL team. Waiting for the confirmation mail.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "328",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "13.4",
        "ppa_tariff ": "3.9",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "We have submitted the revised PIS based on the input given by client on 16th March 2022.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "329",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "3.7",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Under discussion with the client.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "330",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.9",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "New lead . EB bill analysis is under progress.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "331",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "PB",
        "credit_rating": "NA",
        "dc_capacity_mwp": "31",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "EB bill analysis has been done and PIS prepared.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "332",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.73",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted and few queries to be replied.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "333",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "31",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS is shared with Radiance team.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "334",
        "fy": "21-22",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Telangana",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.092",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Lost ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "335",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "AA",
        "dc_capacity_mwp": "0.96",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Under Discussion ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "336",
        "fy": "21-22",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.13",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Commercial Offer submitted.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "337",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "EB bill analysis to be done. Rs. 4.5  tariff given. Requested customer for 5 years balance sheet.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "338",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "NA",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PQ is submitted.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "339",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Will take forward after PPA signing of Phase 1",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "340",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "EB  Bill anaysis to be done",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "341",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.8",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be shared",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "342",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Revised proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "343",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "50",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal is under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "344",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "NA",
        "dc_capacity_mwp": "80",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Site Survey to be done",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "345",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "68",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS submitted to Radiance",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "346",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Telangana",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.13",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS to be shared",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "347",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be shared. We will share the same by tomorrow.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "348",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Lost on basis of pricing",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "18"
    },
    {
        "id": "349",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA",
        "dc_capacity_mwp": "2.4",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"27.05- Revised offer submitted."
    },
    {
        "id": "350",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Haryana",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "As per client, project is not economically viable.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "351",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Project lost based on pricing.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "20"
    },
    {
        "id": "352",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Odisha",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Analysis to be done and also need find the solar park",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "353",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "14",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Solar Park cost is under preparation",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "354",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "West Bengal",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A+",
        "dc_capacity_mwp": "2.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Details shared with Design team",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "355",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Details shared with Design team",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "356",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "4.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Revised termsheet to be shared",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "357",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Telangana",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "358",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "5.5",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted and already first round of meeting done.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "359",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB- ",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Details awaited from client. Credit Rating to be revised",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "360",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "8",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Project will be done through Anand Tata Manji under GCOA",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "361",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "21.3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Customer is not willing to share the details",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "362",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS ready and will be reviewed next week.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "363",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "4.6",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "This is Solar Wind Hybrid project with 10MW Wind Plant and 3.3 MW Solar Plant.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "364",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Punjab",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "1.3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS is under review.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "365",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "9",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Details has been shared with Design team  for Array layout, PIS, PV Syst report",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "366",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "3.19",
        "ppa_tariff ": "4.35",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Discussion with client has been done. We need to submit the proposal under TPOA mode.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "367",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "14.5",
        "ppa_tariff ": "3.95",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "368",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "10.9",
        "ppa_tariff ": "4.35",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Comparison between GCOA & TPOA is shared and final proposal will be shared by today",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "369",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "370",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Extreme",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Profile Sent, hold by customer",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "371",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Extreme",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Sent.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "372",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Extreme",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Profile sent.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "373",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Discussion",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "374",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Profile sent.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "375",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "Fortune500",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Discussion to sign LOI",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "376",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Initial Level",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "377",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Profile sent.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "378",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "FitchAA",
        "dc_capacity_mwp": "35",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Intial Level",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "379",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Extreme",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Interested to Third Party",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "380",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Termsheet sent. Waiting for meeting call.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "381",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "0.075",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"Initial Level"
    },
    {
        "id": "382",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.1",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Commercial offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "122"
    },
    {
        "id": "383",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted and it is under review.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "384",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "NA",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"Revised offer submitted. "
    },
    {
        "id": "385",
        "fy": "21-22",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "FL",
        "capex_opex": "FLOATING",
        "bd_owner": "VL",
        "credit_rating": "stateGovt",
        "dc_capacity_mwp": "100",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Awaiting reply on Pre-bid queries mailed to client(NMMC)",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "124"
    },
    {
        "id": "386",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "31.10- Project delayed from client end. New RFQ shall be provided by April 2023.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "21"
    },
    {
        "id": "387",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Javed Alam in conversation with Mr. Ganatra(Client Side) for project finalisation. Expected order closure in April 2022.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "388",
        "fy": "21-22",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.062",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "120"
    },
    {
        "id": "389",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Array layout mailed to client for capacity confirmation. Awaiting roof details for 4th Bldg from client",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "390",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "PB",
        "credit_rating": "AA",
        "dc_capacity_mwp": "3.2",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Initial price shared with client",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "391",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB(stable)",
        "dc_capacity_mwp": "7.83",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "392",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA-",
        "dc_capacity_mwp": "2.3",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"26.05- Only to submit an offer. As per Kiran, the customer is biased and shall not finalise order with us."
    },
    {
        "id": "393",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "0.025",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Commercial offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "394",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.6",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Commercial offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "395",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "Withdrawn",
        "dc_capacity_mwp": "1",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Part of Jindal Poly Films Group. Lost to Roofsol due to pricing.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "49"
    },
    {
        "id": "396",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A+",
        "dc_capacity_mwp": "13.3",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "397",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A+",
        "dc_capacity_mwp": "45",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "398",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "399",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A-",
        "dc_capacity_mwp": "5.4",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "400",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Plant being upgraded",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "401",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "ASK",
        "credit_rating": "BBB- ",
        "dc_capacity_mwp": "4.3",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "This is for capex. He has the land also",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "402",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "ASK",
        "credit_rating": "BelowBBB-",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "New lead. need to talk in detail",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "403",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttarakhand",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "ASK",
        "credit_rating": "BelowBBB-",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "New plant opened up. Exchange unviable",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "404",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A",
        "dc_capacity_mwp": "7",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Meeting with senior management next week",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "405",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "0.22",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Site Survey Done.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "406",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "A",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"04.10- Revised offer, ROI working submitted to client."
    },
    {
        "id": "407",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "AA",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "12",
        "loa_expected_by": "",
        "remarks": "In talks with them",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "408",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "15",
        "loa_expected_by": "",
        "remarks": "Meter installation going on",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "409",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttarakhand",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "ASK",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "0.5",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "10",
        "loa_expected_by": "",
        "remarks": "Need GM on the land adjacent to their plant",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "410",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "1.2",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "15",
        "loa_expected_by": "",
        "remarks": "26000 unit consumption per day",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "411",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "BBB- ",
        "dc_capacity_mwp": "2.5",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "12",
        "loa_expected_by": "",
        "remarks": "New Plant just installed",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "412",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "19",
        "ppa_tariff ": "4.1",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "413",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "414",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "AA-",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "12",
        "loa_expected_by": "",
        "remarks": "Received Bills of 1 unit. Bills of 2nd unit awaited",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "415",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A-",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "12",
        "loa_expected_by": "",
        "remarks": "They have 2 units of 3.5 MW and 1.9 MW. ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "416",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "AAA",
        "dc_capacity_mwp": "0.256",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Dropped",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "417",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "3.8",
        "ppa_tariff ": "4.45",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "418",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "75",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS is under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "419",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Haryana",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "0.75",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Radiance is submitting the proposal",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "420",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "1.35",
        "ppa_tariff ": "4.55",
        "status": "Extreme",
        "weeks_loa_expected": "3",
        "loa_expected_by": "17-08-2022",
        "remarks": "Term Sheet is under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "421",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "2.7",
        "ppa_tariff ": "4.05",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "422",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "4.45",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal will be submitted by Monday",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "423",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "3.8",
        "ppa_tariff ": "4.35",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "424",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "ASK",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "5",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "3",
        "loa_expected_by": "",
        "remarks": "Need new park with connectivity for the client",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "425",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "VL",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"PPA & RFP documents submitted to Colt with comments from Radiance. Meeting done. Order closure in October."
    },
    {
        "id": "426",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Haryana",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.202",
        "ppa_tariff ": "",
        "status": "Lost",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Foreign Subsidiary A+ credit rating.(Fitch)Rooftop & Carport solar installation. Lost in bidding due to pricing.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "55"
    },
    {
        "id": "427",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "0.05",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"20.07- Capacity upto 20 kW for RCC rooftop possible. Tin shed to be replaced as more than 15 years old and corroded. Client looking for funds."
    },
    {
        "id": "428",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Rajasthan",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "12",
        "loa_expected_by": "",
        "remarks": "Mr. Trilok is out of state. Will get back next week",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "429",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "AA",
        "dc_capacity_mwp": "2",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "12",
        "loa_expected_by": "",
        "remarks": "Out of station. Will contact on Monday",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "430",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "AT",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "0.72",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "431",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "36",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "We are going with Wind Solar Hybrid with  36MWp Solar and 6.6MW Wind.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "432",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "ICRAA1",
        "dc_capacity_mwp": "0.308",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Preliminary Offer submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "433",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "AA",
        "dc_capacity_mwp": "6.5",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "15",
        "loa_expected_by": "",
        "remarks": "Meeting Next week",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "434",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "ASK",
        "credit_rating": "Unrated",
        "dc_capacity_mwp": "6",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "20",
        "loa_expected_by": "",
        "remarks": "Meeting after 7th August",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "435",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "AA",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "20",
        "loa_expected_by": "",
        "remarks": "Need a meeting with their consultant",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "436",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "ASK",
        "credit_rating": "A",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "21",
        "loa_expected_by": "",
        "remarks": "Factory construction going on",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "437",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "7.29",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS is under review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "438",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "4.59",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "PIS Under Review",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "439",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "4.3",
        "ppa_tariff ": "",
        "status": "LOA",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "440",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AT",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.1",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Commercial offer Submitted.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "441",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "3.2",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "442",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "2.7",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "443",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "3.8",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "444",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "4.05",
        "ppa_tariff ": "4.4",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "445",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "15",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "446",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "3",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "447",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Gujarat",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "PB",
        "credit_rating": "A",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "448",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "PB",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "100",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Site survey is under progress",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "449",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "0.9",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "450",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Bihar",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "1.4",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "451",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Odisha",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "2.1",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "452",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "A",
        "dc_capacity_mwp": "0.259",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"06.07- PV Array layout, PV syst report & Equipment layout submitted. Client to revert after they finalise internally."
    },
    {
        "id": "453",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "VL",
        "credit_rating": "NA",
        "dc_capacity_mwp": "5.13",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"20.07- EB analysis & summary shared with Col Pravir Mishra. Comparison done between RT-BTM & GCOA to share with client."
    },
    {
        "id": "454",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Andhra Pradesh",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "AA",
        "dc_capacity_mwp": "34",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal is under progress",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "455",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "0.3",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "456",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AS2",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "0.2",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "457",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA-",
        "dc_capacity_mwp": "0.1",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"02.09- PV array layout, Offer & ROI sheet submitted to client. "
    },
    {
        "id": "458",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA-",
        "dc_capacity_mwp": "0.48",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"07.09- Revised PV array layout, Offer & ROI sheet submitted to client. "
    },
    {
        "id": "459",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA-",
        "dc_capacity_mwp": "0.57",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "12.09- Revised PV array layout submitted. Client looking for MH project closure first.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": "75"
    },
    {
        "id": "460",
        "fy": "22-23",
        "client_name": "Waaree",
        "cp_name": "Waaree Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.55",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"23.09- PV array layout & PV syst report submiited to client. "
    },
    {
        "id": "461",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA-",
        "dc_capacity_mwp": "0.275",
        "ppa_tariff ": "",
        "status": "Cold",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"29.09- Offer & array layout submitted."
    },
    {
        "id": "462",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "A+",
        "dc_capacity_mwp": "0.176",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"14.10- Offer submitted to client(Rushikesh Bhosale)- 40kW RT."
    },
    {
        "id": "463",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "3.78",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "464",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "VL",
        "credit_rating": "A",
        "dc_capacity_mwp": "10.5",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"06.08- Proposal submitted having term sheet & draft LOA."
    },
    {
        "id": "465",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "VL",
        "credit_rating": "NA",
        "dc_capacity_mwp": "2.7",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"10.10- Offer submitted."
    },
    {
        "id": "466",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "3.51",
        "ppa_tariff ": "4.3",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "467",
        "fy": "22-23",
        "client_name": "Bharat Heavy Electricals Ltd",
        "cp_name": "Bharat Heavy Electricals Ltd Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "3.51",
        "ppa_tariff ": "4.45",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal Submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "468",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "34",
        "ppa_tariff ": "3.7",
        "status": "Extreme",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal is under evaluation and final meeting to be done in next week",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "469",
        "fy": "22-23",
        "client_name": "Vikram Solar",
        "cp_name": "Vikram Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A",
        "dc_capacity_mwp": "20",
        "ppa_tariff ": "4.18",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "470",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AS2",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.14",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "471",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AS2",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.9",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Pre bid meeting on 3.10.2022",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "472",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "0.3",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "EB bill analysis is pending",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "473",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "AA",
        "dc_capacity_mwp": "2.5",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"15.10- Revised PV array layout submitted."
    },
    {
        "id": "474",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Gujarat",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "NA",
        "dc_capacity_mwp": "0.45",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "\"17.10- Offer submitted."
    },
    {
        "id": "475",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "West Bengal",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "NA",
        "dc_capacity_mwp": "3.72",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "476",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "8",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "477",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Uttar Pradesh",
        "type_of_project": "RT",
        "capex_opex": "OPEX",
        "bd_owner": "AS",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "4",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "478",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Chhattisgarh",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "20",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "479",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BellowBBB+",
        "dc_capacity_mwp": "6.2",
        "ppa_tariff ": "4.3",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "480",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB+",
        "dc_capacity_mwp": "18.6",
        "ppa_tariff ": "3.8",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal to be submitted",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "481",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A+",
        "dc_capacity_mwp": "0.7",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "482",
        "fy": "22-23",
        "client_name": "Adani Group",
        "cp_name": "Adani Group Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "483",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "32",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "484",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Odisha",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "485",
        "fy": "22-23",
        "client_name": "Indosolar",
        "cp_name": "Indosolar Solutions",
        "state": "Maharashtra",
        "type_of_project": "RT",
        "capex_opex": "CAPEX",
        "bd_owner": "AS",
        "credit_rating": "AA",
        "dc_capacity_mwp": "10",
        "ppa_tariff ": "",
        "status": "Warm",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "486",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "NM",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "14.5",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "Proposal need to be submitt by this week ",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "487",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "Maharashtra",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "VL",
        "credit_rating": "FOREIGNSUBSIDIARY",
        "dc_capacity_mwp": "8",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "31.10- Client(Rajshekhar) shall have a VC team call on Wed. 02nd Nov.",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "488",
        "fy": "22-23",
        "client_name": "Ujaas Energy",
        "cp_name": "Ujaas Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "CAPEX",
        "bd_owner": "JA",
        "credit_rating": "UNRATED",
        "dc_capacity_mwp": "35",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "489",
        "fy": "22-23",
        "client_name": "Tata Power Solar",
        "cp_name": "Tata Power Solar Solutions",
        "state": "Tamil Nadu",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "A+",
        "dc_capacity_mwp": "1.8",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "490",
        "fy": "22-23",
        "client_name": "Adani Green Energy",
        "cp_name": "Adani Green Energy Solutions",
        "state": "Karnataka",
        "type_of_project": "GM",
        "capex_opex": "OPEX",
        "bd_owner": "JA",
        "credit_rating": "BBB(stable)",
        "dc_capacity_mwp": "6.75",
        "ppa_tariff ": "",
        "status": "New Lead",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "491",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "",
        "type_of_project": "",
        "capex_opex": "",
        "bd_owner": "",
        "credit_rating": "NA",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    },
    {
        "id": "492",
        "fy": "22-23",
        "client_name": "HHV Solar Technologies Limited",
        "cp_name": "HHV Solar Technologies Limited Solutions",
        "state": "",
        "type_of_project": "",
        "capex_opex": "",
        "bd_owner": "",
        "credit_rating": "NA",
        "dc_capacity_mwp": "",
        "ppa_tariff ": "",
        "status": "",
        "weeks_loa_expected": "",
        "loa_expected_by": "",
        "remarks": "",
        "Last Connected & ": "",
        "Offer submitted on": "",
        "Procurement Process": "",
        "AC Capacity-Mw": "",
        "PPA Rs/Kwh for 15 yrs": "",
        "PPA Rs/Kwh for 20 yrs": "",
        "Offer No.": ""
    }
]
